import React from 'react'
import reactStamp from 'react-stamp'
import DatePickerDialog from '../DatePickerDialog';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';
import Clear from 'material-ui/svg-icons/content/clear';
import './health.css'

export default reactStamp(React).compose({

    init(){
        this.handleChange = this.handleChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.remove = this.remove.bind(this);
    },

    render() {
        return (
            <div>
                <div className="group-item-container">
                    <div className="select-field">
                        <SelectField value={this.props.id} onChange={this.handleChange} hintText="Select value">
                            {this.getMenuItems(this.props.otherData)}
                        </SelectField>
                    </div>
                        <DatePickerDialog onsetDate={this.props.onsetDate} onDateChange={this.handleDateChange}/>
                    <FlatButton
                        className="button"
                        label="Remove"
                        primary={true}
                        icon={<Clear />}
                        onTouchTap={this.remove}
                    />
                </div>
                <div className="divider-light"></div>
            </div>
        )
    },

    remove(){
        this.props.removeGroupItem(this.props.id);
    },

    handleChange(event, id, value){
        if (this.props.id == value) return;
        let item = {
            "rowNumber": this.props.rowNumber,
            "oldId": this.props.id,
            "onsetDate": this.props.onsetDate,
            "newId": value,
            "status": "true",
            "type": this.props.type
        };
        this.props.handleNameChange(item)
    },

    handleDateChange(date){
        let item = {
            "id": this.props.id,
            "onsetDate": date,
            "name": this.props.name,
            "status": this.props.status,
            "type": this.props.type,
        };
        this.props.handleDateChange(item)
    },

    getMenuItems(groupItems){
        let items = [];
        for (let item in groupItems) {
            if (groupItems[item].id == this.props.id || groupItems[item].status != "true")
                items.push(
                    <MenuItem
                        key={item}
                        value={groupItems[item].id}
                        primaryText={groupItems[item].name}
                    />
                )
        }
        return items;
    },

});


/** WEBPACK FOOTER **
 ** ./src/app/components/Health/GroupItem.js
 **/